// src/component/layouts/MainLayout.js
import NavbarComponent from "../shared/NavbarComponent";
import Footer from "../Footer";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  return (
    <>
      <NavbarComponent />
      <Outlet />
      <Footer />
    </>
  );
}
